import { Navigate } from "react-router-dom";
const isAuthenticated = () => {
  return !!localStorage.getItem("hrms_admin_token");
};

const ProtectedRouteAdmin = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/admin-login" replace />;
};

export default ProtectedRouteAdmin;